export default "__VITE_ASSET__DXI5mFzn__"